module.exports = __webpack_public_path__ + "static/022-9e644aa7ce087161afb7973bc7cc6c27.jpg";